import React from 'react';

import propTypes from 'prop-types';

export default class QuickShopOptionType extends React.Component {
  static propTypes = {
    title: propTypes.object.isRequired,
    children: propTypes.array.isRequired,
  };

  render() {
    const { title, children } = this.props;

    return (
      <fieldset className="greyish-brown quick-shop-option-category">
        <legend>{title}</legend>
        {children}
      </fieldset>
    );
  }
}
